(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mm-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mm-photo-slider')) {
  customElements.define('mm-photo-slider', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const on = (node, name, handler, options = {}) => node?.addEventListener(name, handler, { ...options, signal: this.controller.signal });
      this.slides = [...this.querySelectorAll('.hero-photo-slide')];
      this.dots = [...this.querySelectorAll('.hero-photo-dot')];
      this.current = 0;
      const controls = this.querySelector('.hero-photo-controls');
      if (!this.slides.length) return;
      if (controls) controls.hidden = this.slides.length < 2;
      on(this.querySelector('.hero-photo-previous'), 'click', () => this.show(this.current - 1));
      on(this.querySelector('.hero-photo-next'), 'click', () => this.show(this.current + 1));
      this.dots.forEach((dot, index) => on(dot, 'click', () => this.show(index)));
      on(this, 'keydown', event => {
        if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.show(this.current + (event.key === 'ArrowRight' ? 1 : -1));
      });
      const frame = this.querySelector('[data-photo-slides]');
      let start;
      on(frame, 'pointerdown', event => {
        start = event.pointerType === 'touch' || event.pointerType === 'pen' ? { x: event.clientX, y: event.clientY, id: event.pointerId } : null;
      }, { passive: true });
      on(frame, 'pointerup', event => {
        if (!start || start.id !== event.pointerId) return;
        const x = event.clientX - start.x;
        const y = event.clientY - start.y;
        start = null;
        if (Math.abs(x) > 45 && Math.abs(x) > Math.abs(y) * 1.5) this.show(this.current + (x < 0 ? 1 : -1));
      }, { passive: true });
      on(frame, 'pointercancel', () => { start = null; }, { passive: true });
      on(document, 'shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId || slide === event.target || slide.contains(event.target));
        if (index >= 0) this.show(index, false);
      });
      this.show(0, false);
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
    show(index, announce = true) {
      this.current = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, number) => { slide.hidden = number !== this.current; });
      this.dots.forEach((dot, number) => {
        if (number === this.current) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      const selected = this.slides[this.current];
      if (announce) {
        const status = this.querySelector('.hero-photo-status');
        if (status) status.textContent = selected.getAttribute('aria-label') + (selected.dataset.caption ? ': ' + selected.dataset.caption : '');
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
